import { render } from "./VabeneAddCampagePage.vue?vue&type=template&id=0d6b87ad&ts=true"
import script from "./VabeneAddCampagePage.vue?vue&type=script&lang=ts"
export * from "./VabeneAddCampagePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__